module.exports = __webpack_public_path__ + "static/the-moment-of-lift-8845a66ba572ed21a8fb41a996058eb7.jpg";